<div class="mtest-medical-test-item">
  <div class="pasi-grey-box p-3" [class.pasi-grey-box_blue]="canSchedule && !appointmentDate">
    <div class="d-flex align-items-center">
      <div *ngIf="date" class="d-flex align-items-center">
        <i class="icosun-calendar mtest-medical-test-item_icon"></i>
        <div class="pasi-subtitle_regular mtest-medical-test-item_date ml-2">
          <span>{{'SI_DATE_APPLICATION' | translate}} </span>
          <span>{{date | amDateFormat: 'L'}}</span>
        </div>
      </div>
      <div class="ml-auto">
        <div *ngIf="requestId">
          <a routerLink="/medical-test/{{requestId}}/detail"
             class="mtest-medical-test-item_link"
             [attr.aria-label]="'SI_DETAIL_MEDICAL_TEST' | translate">
            <i class="icosun-arrow_top_right"></i>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf="requestTypeName" class="pasi-title_main mb-2">{{requestTypeName}}</div>
    <div class="row pasi-subtitle_regular mtest-medical-test-item_info mb-3">
      <div *ngIf="centerName" class="col-12 col-sm-auto">
        <div class="d-flex align-items-center">
          <i class="icosun-map mtest-medical-test-item_icon"></i>
          <span class="ml-2 text-truncate">{{centerName}}</span>
        </div>
      </div>
      <div *ngIf="serviceName" class="col-12 col-sm-auto">
        <div class="d-flex align-items-center">
          <i class="icosun-medicine mtest-medical-test-item_icon"></i>
          <span class="ml-2 text-truncate">{{serviceName}}</span>
        </div>
      </div>
    </div>
    <si-mtest-medical-test-icon [requestId]="requestId"
                                [appointmentDate]="appointmentDate"
                                [canSchedule]="canSchedule"
                                [requestTypeId]="requestTypeId"
    ></si-mtest-medical-test-icon>
  </div>
</div>
